var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-content',{attrs:{"pa-0":""}},[_c('global-tool-bar'),_c('router-view'),_c('notification-container')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }